import {doSuccessFailureActions} from '../_utils/actions.js';

export const FETCH_UPDATES = doSuccessFailureActions('FETCH_UPDATES');

export function fetchUpdates(parent) {
  return {type: FETCH_UPDATES.do, parent};
}

export function fetchUpdatesSuccess(payload, parent) {
  return {type: FETCH_UPDATES.success, payload, parent};
}

export function fetchUpdatesFailure(err, parent) {
  return {type: FETCH_UPDATES.failure, err, parent};
}



// WEBPACK FOOTER //
// ./src/redux/updates/actions.js